import { useState, useEffect } from "react";
import useGetProductPrices from "../../../Components/BasketPage/Hooks/useGetProductPrices";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import ProductThreshold from "../../../Components/Components/ProductThreshold";
import ProductAvailabilityLevel from "../../../Components/Components/ProductAvailabilityLevel";
import ProductBuyBtn from "../../Shop/Components/ProductComponents/ProductBuyBtn";
import useHandleAddToBasketBtn from "../../Shop/Hooks/useHandleAddToBasketBtn";
import { useCart } from "../../../Providers/CartProvider";
import NewPromoSellOutTag from "../../../Components/Components/NewPromoSellOut/NewPromoSellOutTag";
import NewPromoSellOutOldPrice from "../../../Components/Components/NewPromoSellOut/NewPromoSellOutOldPrice";
import { useOffers } from "../../../Providers/OffersProvider";
import { useParams } from "../../../Providers/ParamsProvider";

const AddToBasketSection = ({ product }) => {
    const { GetProductQuantityInCart, cartItems } = useCart()
    const [quantityInCart, setQuantityInCart] = useState(0)
    const [quantity, setQuantity] = useState(product.salesRatio > 0 ? product.salesRatio : 1)
    const { handleBtnOnClick } = useHandleAddToBasketBtn(product, quantity);
    const { priceNet, priceGross } = useGetProductPrices(product, quantityInCart)
    const { savedOfferId, getProductQuantityInSavedOffer, selectedSavedOffer } = useOffers()
    const { isMobile } = useParams()

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
        else {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [[], savedOfferId])

    useEffect(() => {
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow)
    }, [quantityInCart])

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [product, cartItems])

    useEffect(() => {
        if (savedOfferId != -1 && selectedSavedOffer && selectedSavedOffer.basketItems) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [selectedSavedOffer])

    const OnChange = (e) => {
        let value = e.target.value
        setQuantity(value);
    }

    const fontSize = isMobile ? '12px' : '16px'

    return (
        <div className="main-container-holder ps-5 pe-5">
            <div style={{ margin: '0 0 0 -16px' }}>
                <NewPromoSellOutTag
                    product={product}
                    isBigTag={true}
                    fontSize={fontSize}
                />
            </div>
            <div className="row">
                <div className="col">
                    <div className="d-flex align-items-center">
                        <span className="price-net">{ConvertPriceToString(priceNet, product.currency)}</span>
                        <NewPromoSellOutOldPrice product={product} />
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center">
                <span className="price-gross me-2">{ConvertPriceToString(priceGross, product.currency)}</span>
                <span className="light-text-color ms-2">{'brutto ' + product.taxRate} %</span>
            </div>
            <div className="mt-4 mb-4">
                <ProductBuyBtn
                    product={product}
                    quantityInCart={quantityInCart}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    OnChange={OnChange}
                    onClick={handleBtnOnClick}
                    isBasketSummary={false}
                    isProductDetail={true}
                />
            </div>
            <div className="mt-3">
                <ProductThreshold
                    product={product}
                    isProductDetails={true}
                />
            </div>
            <div className="mt-3">
                <ProductAvailabilityLevel
                    product={product}
                />
            </div>

        </div>
    )
}

export default AddToBasketSection